import { useState, useEffect, useRef } from 'react';
import * as React from 'react';
import { AuthUserType } from '@sdk/authentication/types/AuthUserType';
import { SaveClientFlags } from '@sdk/authentication/types';

import PopupSurveyContainer from '../survey/PopupSurveyContainer';
import SurveyCloseButton from '../survey/SurveyCloseButton';

import { sendSurveyFeedback, shouldDisplaySurvey } from './utils';
import AfterSignupSurveySteps from './AfterSignupSurveySteps';

const FIRST_RUN_DISPLAY_DELAY = 180000; //3mins
const DISPLAY_DELAY = 10000;

type Props = {
  user: AuthUserType;
  saveClientFlags: SaveClientFlags;
  firstRun?: boolean;
};

const AfterSignupSurvey: React.FC<React.PropsWithChildren<Props>> = ({
  user,
  saveClientFlags,
  firstRun,
}) => {
  const feedbackSentRef = useRef(false);
  const [isVisible, setIsVisible] = useState(false);
  const [comment1, setComment1] = useState('');
  const [comment2, setComment2] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const onClose = (): void => {
    if (!feedbackSentRef.current) {
      sendSurveyFeedback({ comment1, comment2 }, { user, saveClientFlags });
    }

    setIsVisible(false);
  };

  useEffect(() => {
    if (shouldDisplaySurvey(user)) {
      const delay = firstRun ? FIRST_RUN_DISPLAY_DELAY : DISPLAY_DELAY;
      const timeoutId = setTimeout(() => setIsVisible(true), delay);
      return (): void => clearTimeout(timeoutId);
    }
  }, [firstRun, user]);

  useEffect(() => {
    if (!feedbackSentRef.current && submitted) {
      sendSurveyFeedback({ comment1, comment2 }, { user, saveClientFlags });
      feedbackSentRef.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [comment1, comment2, submitted, user]);

  if (!isVisible) {
    return null;
  }

  return (
    <PopupSurveyContainer>
      <SurveyCloseButton onClose={onClose} />
      <AfterSignupSurveySteps
        comment1={comment1}
        setComment1={setComment1}
        comment2={comment2}
        setComment2={setComment2}
        submitForm={(): void => setSubmitted(true)}
        closeSurvey={onClose}
      />
    </PopupSurveyContainer>
  );
};

export default AfterSignupSurvey;
